import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const originalPath = window.location.pathname;
if (!sessionStorage.getItem('originalPath')) {
  sessionStorage.setItem('originalPath', originalPath);
  console.log('Original path set in main.ts:', originalPath);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
